/**
 * Application Configuration — ainode-auditor read-only console.
 *
 * All authentication is handled via AWS Marketplace JWT tokens verified by
 * the API Gateway custom authorizer. The console only ever talks to API
 * Gateway (design decision #7) — it never touches the executor Function URL
 * and never reads S3 directly.
 */

// API Configuration
export const API_URL = import.meta.env.VITE_API_URL;
export const AWS_REGION = import.meta.env.VITE_AWS_REGION || 'us-east-1';

// Audit executor Function URL (POST /evaluate + POST /recommend) used by the
// "New Audit" flow. Separate from API_URL: the console API is read-only.
export const AUDIT_API_URL = import.meta.env.VITE_AUDIT_API_URL || 'https://audit.ainode.surus.lat';

// AWS Marketplace public listing URL (per-product prodview slug)
export const MARKETPLACE_URL = import.meta.env.VITE_MARKETPLACE_URL || 'https://aws.amazon.com/marketplace';

// Auth mode is always marketplace
export const AUTH_MODE = 'marketplace';
export const USE_MARKETPLACE_AUTH = true;
